/**
 * Feather icons that require stroke styling (stroke-current stroke-2)
 * Used by ZIcon.vue component and buildIcons.js script
 *
 * Keep this list in sync with feather icon usage across the app.
 * The build-icons script validates that all used feather icons are listed here.
 */

export const STROKE_FEATHER_ICONS = [
  'activity',
  'alert-circle',
  'alert-triangle',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'arrow-up-right',
  'at-sign',
  'bar-chart',
  'bar-chart-2',
  'book',
  'book-open',
  'calendar',
  'check',
  'check-circle',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'chevrons-up',
  'circle',
  'code',
  'corner-up-left',
  'cpu',
  'download',
  'edit',
  'edit-2',
  'edit-3',
  'external-link',
  'eye',
  'eye-off',
  'dribbble',
  'fast-forward',
  'feather',
  'file',
  'file-plus',
  'file-text',
  'filter',
  'flag',
  'frown',
  'git-branch',
  'git-commit',
  'git-pull-request',
  'globe',
  'headphones',
  'help-circle',
  'home',
  'layers',
  'layout',
  'link-2',
  'log-in',
  'log-out',
  'mail',
  'menu',
  'message-square',
  'minus',
  'minus-circle',
  'more-horizontal',
  'more-vertical',
  'package',
  'paperclip',
  'pause-circle',
  'pie-chart',
  'play',
  'play-circle',
  'plus',
  'plus-circle',
  'refresh-ccw',
  'refresh-cw',
  'repeat',
  'save',
  'search',
  'send',
  'settings',
  'share',
  'slash',
  'sliders',
  'target',
  'trash',
  'trash-2',
  'trending-up',
  'upload',
  'user',
  'user-check',
  'user-plus',
  'user-x',
  'users',
  'x',
  'x-circle',
  'zap',
  'disc',
  'list',
  'star',
  'info',
  'copy',
  'credit-card',
  'clipboard'
]
